import { ResultsIcon } from "@/components/icons/focus/results-icon";
import { TargetIcon } from "@/components/icons/focus/target-icon";
import { MoneyIcon } from "@/components/icons/focus/money-icon";

export function Focus() {
  return (
    <div className="w-full h-full flex flex-col gap-4">
      {/* First Row - OKRs */}
      <div className="bg-card border border-border rounded-3xl p-4 flex-[1] grid grid-cols-2 transition-all duration-300 hover:border-primary/40 hover:transform hover:-translate-y-1 hover:shadow-lg">
        {/* Left Column - Icon centered */}
        <div className="flex items-center justify-center mr-6">
          <ResultsIcon className="w-26 h-26" />
        </div>

        {/* Right Column - Text centered */}
        <div className="flex items-center justify-center">
          <div className="flex flex-col text-left mr-7">
            <h4 className="font-heading text-foreground text-xl mb-2">OKRs</h4>
            <p className="text-muted-foreground font-light text-sm">Hit your targets<br />without hiring</p>
          </div>
        </div>
      </div>

      {/* Second Row - KPIs and ROI */}
      <div className="flex flex-row gap-4 flex-[2]">
        {/* Left box - KPIs */}
        <div className="bg-card border border-border rounded-3xl p-4 flex-1 flex flex-col items-center justify-center text-center transition-all duration-300 hover:border-primary/40 hover:transform hover:-translate-y-1 hover:shadow-lg">
          <TargetIcon className="w-14 h-14 mb-6" />
          <h4 className="font-heading text-foreground text-lg mb-2">KPIs</h4>
          <p className="text-muted-foreground font-light text-sm">Track what matters<br />automatically</p>
        </div>

        {/* Right box - ROI */}
        <div className="bg-card border border-border rounded-3xl p-4 flex-1 flex flex-col items-center justify-center text-center transition-all duration-300 hover:border-primary/40 hover:transform hover:-translate-y-1 hover:shadow-lg">
          <MoneyIcon className="w-14 h-14 mb-6" />
          <h4 className="font-heading text-foreground text-lg mb-2">ROI</h4>
          <p className="text-muted-foreground font-light text-sm">Spend less.<br />Make more.</p>
        </div>
      </div>
    </div>
  );
}